<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-2.19147e-06 6.5L1.5 6.5L3 8.5L8.5 8.5L6 -6.1196e-07L8 -5.24537e-07L13 8.5L18.5 8.5C18.9167 8.5 19.271 8.646 19.563 8.938C19.855 9.23 20.0007 9.584 20 10C20 10.4167 19.854 10.771 19.562 11.063C19.27 11.355 18.916 11.5007 18.5 11.5L13 11.5L8 20L6 20L8.5 11.5L3 11.5L1.5 13.5L-2.49745e-06 13.5L0.999998 10L-2.19147e-06 6.5Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconAirplane'
}
</script>
